/** API / form values for blacklist contact type. */
export const CONTACT_TYPE = {
  FAX: "FAX",
  EMAIL: "EMAIL",
  PHONE: "PHONE",
};

/**
 * Map each contact type to its UI and validation meta.
 * @typedef {{ optionLabel: string, displayLabel: string, confirmDialogLabel: string, placeholder: string, isNumeric: boolean, isDefaultForNewEntry?: boolean }} BlacklistedContactTypeMeta
 * @type {Record<string, BlacklistedContactTypeMeta>}
 */
export const BLACKLISTED_CONTACT_META = {
  [CONTACT_TYPE.EMAIL]: {
    optionLabel: "EMAIL",
    displayLabel: "Email Address",
    confirmDialogLabel: "email address",
    placeholder: "Enter email address",
    isNumeric: false,
  },
  [CONTACT_TYPE.PHONE]: {
    optionLabel: "PHONE",
    displayLabel: "Phone Number",
    confirmDialogLabel: "phone number",
    placeholder: "Enter phone number",
    isNumeric: true,
  },
  [CONTACT_TYPE.FAX]: {
    optionLabel: "FAX",
    displayLabel: "Fax Number",
    confirmDialogLabel: "fax number",
    placeholder: "Enter fax number",
    isNumeric: true,
    isDefaultForNewEntry: true,
  },
};

/** Order of options in the contact-type select (not implied by object key order). */
export const BLACKLISTED_CONTACT_TYPE_ORDER = [
  CONTACT_TYPE.FAX,
  CONTACT_TYPE.EMAIL,
  CONTACT_TYPE.PHONE,
];

/** Contact types allowed when creating or editing a blacklisted contact (API + UI). */
export const BLACKLISTED_CONTACT_TYPES = BLACKLISTED_CONTACT_TYPE_ORDER.map((type) => ({
  value: type,
  label: BLACKLISTED_CONTACT_META[type].optionLabel,
}));

export const BLACKLISTED_CONTACT_TYPE_VALUES = BLACKLISTED_CONTACT_TYPE_ORDER;

/** Defaults when creating a new blacklisted contact (driven by `isDefaultForNewEntry` on meta). */
export const BLACKLISTED_CONTACT_DEFAULTS = {
  contactType:
    Object.entries(BLACKLISTED_CONTACT_META).find(([, m]) => m.isDefaultForNewEntry)?.[0] ??
    CONTACT_TYPE.FAX,
};

/**
 * Label for the contact value field in the blacklist create/edit modal.
 * @param {string} contactType
 * @returns {string}
 */
export function getLabel(contactType) {
  return BLACKLISTED_CONTACT_META[contactType]?.displayLabel ?? "Contact";
}

/** Short noun phrase for confirm dialogs (e.g. "fax number"). */
export function getBlacklistedContactKindLabel(contactType) {
  return BLACKLISTED_CONTACT_META[contactType]?.confirmDialogLabel ?? "contact";
}

/** Placeholder for the contact value input in the blacklist modal. */
export function getBlacklistedContactPlaceholder(contactType) {
  return BLACKLISTED_CONTACT_META[contactType]?.placeholder ?? "Enter contact";
}
